/* eslint-disable react-hooks/exhaustive-deps */
import {useContext} from 'react'
import useFilters from '../../../../hook/useFilters'
import useApi from '../../../../services/useApi'
import {ProjectDetailsContext} from '../../context'

const useGetTasksReportsData = () => {
  const Api = useApi()
  const {projectId} = useContext(ProjectDetailsContext)
  const initialFilters = {
    page: 1,
    limit: 30,
    sort_by: 'project_name/1',
    project_id: projectId,
    report_type: 'individual_project_task_report',
  }

  const {filters, onSearch, onSortingChange, searchValue, onPageChange, setMultipleFilters} =
    useFilters(initialFilters, {
      sortType: 'number',
    })

  const {
    data: response,
    isFetching,
    refetch,
  } = Api.useGetQuery(
    `/agile/projects/task-report`,
    {
      queryId: 'task-report',
      filters: filters,
    },
    {
      enabled: projectId !== '',
    }
  )

  const onProjectChange = (id: any) => {
    setMultipleFilters({
      project_id: id,
      page: 1,
    })
  }

  return {
    tasksReportsData: response?.data?.task_report?.data || [],
    pagination: response?.data?.task_report?.meta?.pagination || {},
    filtersData: response?.data?.filters || [],
    filters,
    isLoading: isFetching,
    onSortingChange,
    onProjectChange,
    onPageChange,
    onSearch,
    searchValue,
    refetch,
  }
}

export default useGetTasksReportsData
